import { ValidationProblemDetails } from "hoksource";
import { ModelTypeBase } from "../models/entities/model-type-base";
import { DirectoryComponent } from "../directory-shared/DirectoryComponent";
import { EditStateBase } from "../types/EditStateBase";
import { ModelTypesBaseProps } from "./Root";


export class EditController<T extends ModelTypeBase>
extends DirectoryComponent<ModelTypesBaseProps<T>,
EditStateBase<T>>
{

    id:string;

    constructor(props)
    {
        super(props);

        this.state = {

            input:{} as T
        };
    }


    componentDidMount()
    {
        this.id = this.getQueryParam("id");

        if(this.id)
        {
            
            var service = new this.props.serviceType(this.http);
            service.findById(this.id).then(e => this.setState({
                input:e
            }));
        }
    }



    
    handleSubmit = async (evt:React.FormEvent<HTMLFormElement>)=>
    {

        
        evt.preventDefault();

        this.setState({
            errors:null,
            isSubmitting:true,
        });

        
        try
        {
            // success 
            
            var service = new this.props.serviceType(this.http);
            await service.save(this.state.input);

            this.history.goBack();

        }catch(err)
        {


            if(err.status === 400)
            {
                this.setState({errors:(err as ValidationProblemDetails).errors});
            }
        }


        this.setState({isSubmitting:false});
        
        

    }




    
}